/*
 * Shared demo/component script entrypoint.
 *
 * Load this once on pages that need interactive component behavior instead of
 * attaching individual script files per component.
 */

import './header.js';
import './breadcrumb.js';
import './footer.js';

function loadWhenPresent(selector, loader) {
  if (!document.querySelector(selector)) {
    return;
  }

  loader().catch((error) => {
    console.error(`Failed to load module for selector "${selector}"`, error);
  });
}

loadWhenPresent('[data-dropdown]', () => import('./dropdown.js'));
loadWhenPresent('[data-dropdown]', () => import('./dropdown-position.js'));
loadWhenPresent('[data-listgroup-drawer]', () => import('./listgroup.js'));
loadWhenPresent('.carousel__track', () => import('./carousel.js'));
loadWhenPresent('[data-pagination]', () => import('./pagination.js'));
loadWhenPresent('[data-testimonial-carousel]', () =>
  import('./testimonial-carousel.js').then(({ initTestimonialCarousel }) => initTestimonialCarousel())
);
